import { Repository } from "src/firebase/firestore/repository";
import { AiLanguageVoice } from "./entities/ai-language-voice.entity";

class AILanguageVoiceRepository extends Repository<AiLanguageVoice> {
  constructor() {
    super("ai_coach_languages");
  }

  async findById(id: string): Promise<AiLanguageVoice | null> {
    return await super.findById(id) as AiLanguageVoice | null;
  }

  async find(args: any): Promise<(AiLanguageVoice & { id: string })[]> {
    return await super.find(args) as (AiLanguageVoice & { id: string })[];
  }

  async count(where?: any): Promise<number> {
    return await super.count(where);
  }
}

export const aiLanguageVoiceRepository = new AILanguageVoiceRepository();
